import {Box} from '@mui/material';
import React from 'react';

import {MainFooter, PageWrapperLayout} from 'presentation/components';
import {PlanTypeEnum} from 'presentation/constants/bookingTypesEnum';

import {GuideStep} from 'presentation/modules/guide/shared/constants/constants';
import {Location} from 'presentation/modules/guide/shared/ui/components/Location';

import {EarlyAccessModal} from 'presentation/modules/guide/shared/ui/components';
import {SearchDetails} from 'presentation/modules/guide/shared/ui/components/SearchDetails';
import {translations} from 'presentation/translations-new';
import {OdontoGuideHeader} from './components/OdontoGuideHeader';
import {OdontoProvidersResults} from './components/OdontoProvidersResults';
import {useOdontoGuide} from './hooks/useOdontoGuide';

const {titleNetworkProviderOdonto} = translations['pt-br'].privateFlow.guideFlow;

export const OdontoGuide = () => {
	const {
		currentStepState,
		isMobile,
		providers,
		scrollableContentRef,
		loadingNewPageState,
		handleVisible,
		providersError,
		shouldRenderEmptyState,
		allProviders,
		isFetching,
		refetchProvidersQuery,
		onSearchResults,
		isEarlyAccessModalOpen,
		setIsEarlyAccessModalOpen,
		beneficiary,
	} = useOdontoGuide();

	return (
		<PageWrapperLayout title={titleNetworkProviderOdonto}>
			<OdontoGuideHeader allProviders={allProviders} />

			{!currentStepState || currentStepState === GuideStep.LOCATION ? (
				<Location flowType={PlanTypeEnum.ODONTO} />
			) : null}

			{currentStepState === GuideStep.DETAILS ? (
				<SearchDetails type={PlanTypeEnum.ODONTO} onSearchResults={onSearchResults} />
			) : null}

			{currentStepState === GuideStep.RESULTS ? (
				<OdontoProvidersResults
					scrollableContentRef={scrollableContentRef}
					loadingNewPageState={loadingNewPageState}
					handleVisible={handleVisible}
					providers={providers}
					providersError={providersError}
					shouldRenderEmptyState={shouldRenderEmptyState}
					isFetching={isFetching}
					refetchProvidersQuery={refetchProvidersQuery}
				/>
			) : null}

			<EarlyAccessModal
				open={isEarlyAccessModalOpen}
				onClose={() => setIsEarlyAccessModalOpen(false)}
				dtAdesao={beneficiary.dtAdesaoC}
			/>

			<Box
				mt="auto"
				mb={isMobile && currentStepState === GuideStep.DETAILS ? '65px' : undefined}>
				<MainFooter />
			</Box>
		</PageWrapperLayout>
	);
};
